import React from 'react';
import styled from 'styled-components';

const FlexRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  min-height: 22px;
`;

export default FlexRow;
